export default "__VITE_ASSET__D9c2JAfM__"